<template>
  <div>
    <div class="title-section">
      <div class="title">
        <span>研究方向</span>
      </div>
      <div class="title-line"></div>
      <div class="title-subtitle">Research</div>
    </div>
    <div v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.9)">
      <div class="box-content" v-html="teamDetail.researchDirection" v-if="teamDetail.researchDirection"></div>
    </div>
  </div>
</template>

<script>
import {getTeamDetail} from '@/api/api'
import '@/dist/quill.core.css'
import '@/dist/quill.snow.css'
import '@/dist/quill.bubble.css'
export default {
  data () {
    return {
      teamDetail: {},
      loading: true
    }
  },
  created () {
    this.getTeamDetail()
  },
  methods: {
    getTeamDetail () {
      this.loading = true
      getTeamDetail().then(res => {
        if (res.code === 200) {
          this.teamDetail = res.data
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.title-section {
  position: relative;
  margin-bottom: 32px;
}

.title {
  font-size: 36px;
  line-height: 1.4;
  color: #2f4f4f;
  font-weight: 700;
  letter-spacing: 3px;
  animation: titleFloatIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

.title-subtitle {
  position: absolute;
  right: 0;
  top: 10px;
  font-size: 14px;
  color: #888;
  letter-spacing: 8px;
  text-transform: uppercase;
  animation: subtitleFadeIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.5s forwards;
  opacity: 0;
}

@keyframes titleFloatIn {
  from {
    opacity: 0;
    transform: translateY(-40px);
    letter-spacing: 10px;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    letter-spacing: 3px;
  }
}

@keyframes subtitleFadeIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.title-line {
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #2f4f4f, #5a8a8a);
  border-radius: 2px;
  animation: lineSlideIn 1s cubic-bezier(0.22, 1, 0.36, 1) 0.3s forwards;
  transform-origin: left;
  transform: scaleX(0);
}

@keyframes lineSlideIn {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
</style>
